export const PRRemarksToBSRemarksMapping: { [key: string]: string } = {
  ["POPULAR VEHICLES & SERVICES LTD"]: "POPULAR",
  ["POPULAR VEHICLES & SERVICES"]: "POPULAR VEHICLES AND SERVI 000423340182",
  ["SATYAJIT V"]: "SATHYAJITH",
  ["VISION MOTORS PRIVATE LIMITED"]: "VISION MOTORS PVT LTD",
  ["SUNNY OP"]: "SUNNY",
  ["WILLIAM K K"]: "WILLIAM KALIYADAN",
  ["ROSY JACOB"]: "ROSY JOCOB",
  ["KAVITHA OP"]: "KAVITHA",
  ["A J ROBERT"]: "ROBERT",
  ["APOLLO TYRES LTD"]: "APPOLLO TYRES",
  ["ABDUL HAKKIM PLKD"]: "ABDUL HAKKIM",
  ["AMALDEV C"]: "AMALDEV",
  ["AMALDEV C B"]: "AMALDEV",
  ["ANSIYA PLKD"]: "ANSIYA",
  ["ASARUDEEN  PLKD"]: "ASARUDHEEN",
  ["BINOY BALAKRISHNAN"]: "BENOY BALAKRISHNAN",
  ["BINOY BALAKRISHNA"]: "BENOY BALAKRISHNAN",
  ["PRAKASAN E S"]: "PRAKASHAN E S",
};

export enum PaymentRegisterHeaders {
  InstrumentId = "Instr. Id",
  Date = "Date",
  Remarks = "Remarks",
  Withdrawals = "Withdrawals",
  ID = "ID",
}

export enum BankPaymentStatementHeaders {
  Date = "Date",
  TransactionId = "Tran Id",
  InstrumentId = "Instr. Id",
  Remarks = "Remarks",
  Withdrawals = "Withdrawals",
  Deposits = "Deposits",
  Balance = "Balance",
  UTRNumber = "UTR Number",
  ID = "ID",
}

export enum MatchingBSHeadersInPR {
  InstrumentId = "Bank Instrument Id",
  Remarks = "Bank Remarks",
  Withdrawal = "Bank Withdrawal",
  Date = "Bank Date",
}

export const ClearedPaymentRegisterTableHeaders: (
  | PaymentRegisterHeaders
  | MatchingBSHeadersInPR
)[] = [
  PaymentRegisterHeaders.InstrumentId,
  PaymentRegisterHeaders.Date,
  PaymentRegisterHeaders.Remarks,
  PaymentRegisterHeaders.Withdrawals,
  MatchingBSHeadersInPR.Date,
  MatchingBSHeadersInPR.Remarks,
  MatchingBSHeadersInPR.Withdrawal,
  MatchingBSHeadersInPR.InstrumentId,
];
export const PaymentRegisterTableHeaders: PaymentRegisterHeaders[] = [
  PaymentRegisterHeaders.InstrumentId,
  PaymentRegisterHeaders.Date,
  PaymentRegisterHeaders.Remarks,
  PaymentRegisterHeaders.Withdrawals,
];

export const BankStatementTableHeaders: BankPaymentStatementHeaders[] = [
  BankPaymentStatementHeaders.Date,
  BankPaymentStatementHeaders.Remarks,
  BankPaymentStatementHeaders.InstrumentId,
  BankPaymentStatementHeaders.Withdrawals,
  BankPaymentStatementHeaders.Deposits,
  BankPaymentStatementHeaders.Withdrawals,
];
